import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as types from './store/types'
import { api } from '@/api'
import { i18n } from '@appbase/util'
import {initializeAsync as initAppBaseAsync} from '@appbase/module'

Vue.config.productionTip = false

//
// ──────────────────────────────────────────────────────── I ──────────
//   :::::: P O L Y F I L L : :  :   :    :     :        :          :
// ──────────────────────────────────────────────────────────────────
//

import 'fetch-polyfill';
import 'scroll-behavior-polyfill';
import 'location-origin';
import './polyfills/remove.js';

Office.onReady(async (info) => {
    await initAppBaseAsync()
    if(info.host == Office.HostType.Outlook) {   
        api.domain.getAllowedDomains().then(res => {
            setDomain(res);
        });

        new Vue({
            router,
            store,
            i18n,
            render: h => h(App)
        }).$mount('#app')

        itemChanged(Office.context.mailbox.item);
        Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, itemChanged);        
    } 
});

function itemChanged(item?: Office.MessageRead) {   
    console.log('itemChanged', item);
    store.commit(types.CURRENT_MAIL_ITEM, item || null);       
}

function setDomain(domains?: string[]) {
  console.log('setDomain', domains);
  store.commit(types.VALID_DOMAIN, domains);
}


